import { Component } from 'react';
import PropTypes from 'prop-types';

// material-ui
import { Box, Button, Stack, Typography } from '@mui/material';

// ==============================|| LAST-RESORT ERROR BOUNDARY ||============================== //
// Catches render-time exceptions anywhere below it so one broken component
// shows a recoverable message instead of leaving the whole app blank. This is
// a class component because React has no hook equivalent for
// getDerivedStateFromError/componentDidCatch.

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', p: 3 }}>
          <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', maxWidth: '480px' }}>
            <Typography variant="h3">Something went wrong</Typography>
            <Typography variant="body1" color="textSecondary">
              This page hit an unexpected error. Reloading usually fixes it — if it keeps happening, let the team know.
            </Typography>
            <Button
              variant="contained"
              onClick={() => window.location.reload()}
              sx={{ backgroundColor: '#cf6112', '&:hover': { backgroundColor: '#b95709' } }}
            >
              Reload
            </Button>
          </Stack>
        </Box>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
